<template>
    <!--<div class="right-menu">
        <a href="#">
            <i class="icon icon-right-menu"></i>
        </a>
    </div>-->
    <button class="btn btn-secondary sidebar-right-open" :class="css" @click="close = false">
        <i class="icon icon-chevron-up text-white"></i>
    </button>
    <nav class="sidebar-right" :class="{'close': close }">
        <div class="scrollbar-sidebar">
            <button class="btn btn-secondary sidebar-right-close" @click="close = true" style="">x</button>
           <div class="h-100 p-3 overflow-auto">
                <slot></slot>
           </div>            
        </div>
    </nav>
</template>
<script>
    import { reactive, toRefs } from "vue";
    
    export default {
        props: {
            css: {
                default: "",
            },
        },
        components: {
        },
        mounted() {
            const _this = this;
            var sidebar = document.querySelector('.sidebar-right');
            sidebar.addEventListener('click', function(e) {
                if (e.target == sidebar) {
                    _this.close = true;
                }
            });
        },
        setup() {
            const e = reactive({
                close: true,
            });
            return { ...toRefs(e) };
        },
    };
</script>